export const API_COOKIES_INFO = "https://cmp.anycoders.cz/api/cookies/";
export const API_ERROR = "https://errors.anycoders.cz/error";
